/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IAboutModalScope extends ng.IScope {
        modalClose: () => void;
        buildInfo: Object;
        
        year: number;
        timezoneService: Services.TimezoneService;
    }

    /**
     * AboutModelController class
     */
    export class AboutModalController {
        public static templateURL: string = "decorators/modals/about-modal.html";
        public static ID: string = "#id-about-modal";
        public static $name: string = "aboutModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'buildInfo', 'timezoneService'];

        /**
         * Constructor
         */
        constructor($scope: IAboutModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    buildInfo: Object,
                    timezoneService: Services.TimezoneService) {
            
            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);

            $scope.buildInfo = buildInfo;
            $scope.year = new Date().getFullYear();
            $scope.timezoneService = timezoneService;

            $scope.modalClose = (): void => {
                close(undefined);
            };

        }
    }
}